import type {
  DataResponse,
  DeepResearchCreate,
  DeepResearchResponse,
  DeepResearchSummary,
  PaginatedResponse,
  SessionSharingResponse,
  ShareLinkResponse,
  SharePermission,
  ShareResponse,
} from "@/types";
import { api } from "../api";

export const deepResearchService = {
  list: (page = 1, pageSize = 20, status?: string) => {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (status) params.set("status", status);
    return api.get<PaginatedResponse<DeepResearchSummary>>(`/deep-research?${params}`);
  },

  get: (uuid: string) => api.get<DataResponse<DeepResearchResponse>>(`/deep-research/${uuid}`),

  create: (data: DeepResearchCreate) => api.post<DataResponse<DeepResearchResponse>>("/deep-research", data),

  cancel: (uuid: string) => api.post<DataResponse<DeepResearchResponse>>(`/deep-research/${uuid}/cancel`, {}),

  delete: (uuid: string) => api.delete<{ message: string }>(`/deep-research/${uuid}`),

  // Sharing — satisfies ShareServiceAdapter for EntityShareDialog
  getShares: (uuid: string) => api.get<DataResponse<SessionSharingResponse>>(`/deep-research/${uuid}/sharing`),

  shareWithUser: (uuid: string, userUuid: string, permission: SharePermission) =>
    api.post<DataResponse<ShareResponse>>(`/deep-research/${uuid}/sharing/users`, {
      user_uuid: userUuid,
      permission,
    }),

  removeShare: (uuid: string, userUuid: string) => api.delete(`/deep-research/${uuid}/sharing/users/${userUuid}`),

  createShareLink: (uuid: string, permission: SharePermission) =>
    api.post<DataResponse<ShareLinkResponse>>(`/deep-research/${uuid}/sharing/link`, { permission }),

  removeShareLink: (uuid: string, linkUuid: string) => api.delete(`/deep-research/${uuid}/sharing/link/${linkUuid}`),

  accessShareLink: (token: string) => api.get<DataResponse<DeepResearchResponse>>(`/deep-research/shared/${token}`),
};
